
export const SUPPORTED_UPLOAD_EXTENSIONS = [
  ".docx", 
  ".txt", 
  ".csv", 
  ".pdf", 
  ".odt", 
  ".doc", 
  ".xlsx",
  ".jpg",
  ".jpeg",
  ".png"
];

// 前端上傳 Accept 字串 (用於 input accept)
export const UPLOAD_ACCEPT_STRING = SUPPORTED_UPLOAD_EXTENSIONS.join(",");

// 優先順序 (數值越小優先級越高)
export const AI_PARSE_PRIORITY: Record<string, number> = {
  "docx": 1, "txt": 1, "csv": 1,
  "pdf": 2, "jpg": 2, "jpeg": 2, "png": 2,
  "odt": 3, "doc": 3, "xlsx": 3
};

// 輔助函式：取得副檔名優先級
export function getExtensionPriority(filename: string): number {
  const ext = filename.split('.').pop()?.toLowerCase() || "";
  return AI_PARSE_PRIORITY[ext] || 99;
}
